import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactService extends ApiService {

  constructor(http: HttpClient) {
    super(`${environment.apiUrl}`, http);
  }

  getContact(classification?, category?, status?, viewAll?, userID?) {

    let url = '?';
    let count = 0;

    if (viewAll != null && viewAll != undefined) {
      url = url + 'viewAll='+viewAll;
    }
    
    if (userID != null && userID != undefined ) {
        url = url + 'userID='+userID;
    }



    if (classification != undefined && classification != null && classification.length > 0){
      if ((viewAll != null && viewAll != undefined) || (userID != null && userID != undefined)) {
        url = url + '&classification='+ classification;
      } else {
        url = url + 'classification='+ classification;
      }
      
      count ++;
    }

    if (category != undefined && category != null && category.length > 0){
      if (count > 0) {
        url = url + '&category='+ category;
      } else {
        if ((viewAll != null && viewAll != undefined) || (userID != null && userID != undefined)) {
          url = url + '&category='+ category;
        } else {
          url = url + 'category='+ category;
        }
      }      
      count ++;
    }

    if (status != undefined && status != null){
      if (count > 0) {
        url = url + '&status='+ status;
      } else {        
        if ((viewAll != null && viewAll != undefined) || (userID != null && userID != undefined)) {
          url = url + '&status='+ status;
        } else {
          url = url + 'status='+ status;
        }
      }      
      count ++;
    }
    
    return this.getUrl('/contact' + url)
  }

  getContactDetail(id) {
    return this.getUrl('/contact/'+ id);
  }

  postContact(data) {
    return this.postUrl('/contact', data);
  }

  deleteContact(id) {
    return this.deleteUrl('/contact/'+id);
  }
}
